import { Grid } from '@mui/material'
import { FieldArray, FormikProps, FastField, FieldProps } from 'formik'
import { TextField } from 'formik-mui'
import React from 'react'
import { SaveIconButton } from '../../../components/Buttons/SaveIcon'
import { Status } from '../../../hooks/useFetchState'
import { useApi } from '../../../hooks/useApi'
import { Courier, CourierService } from '../../../interfaces/Courier'
import { ApiConfig } from '../../../config/api'
import axios from 'axios'
import { DeleteIconButton } from '../../../components/Buttons/DeleteIcon'
import { PriorizationDDL } from '../priorizationddl'

interface UpdateCourierServicesProps {
  data: FormikProps<Courier>
  getServices: () => void
  notify: (message: string, status: boolean) => void
}

const putCourierService = (
  courierId: number,
  courierServiceId: number,
  dto: Partial<CourierService>
) => {
  const url = new URL(
    `${ApiConfig.CourierApi}/${courierId}/service/${courierServiceId}`
  )

  return axios.put(url.toString(), dto)
}

const deleteCourierService = (courierId: number, courierServiceId: number) => {
  const url = new URL(
    `${ApiConfig.CourierApi}/${courierId}/service/${courierServiceId}`
  )

  return axios.delete(url.toString())
}

export const ModifyCourierServices: React.FC<UpdateCourierServicesProps> = ({
  data: { handleChange, values, initialValues },
  getServices,
  notify
}) => {
  const {
    state: updateCourierServiceState,
    callApi: updateCourierServiceCallApi
  } = useApi()

  const {
    state: deleteCourierServiceState,
    callApi: deleteCourierServiceCallApi
  } = useApi()

  const update = (
    courierServiceId: number,
    name: string,
    typeService: number | null
  ) => {
    requestUpdateCourierService(courierServiceId, {
      name: name,
      typePriorityId: typeService
    })
  }

  const requestUpdateCourierService = (
    courierServiceId: number,
    dto: Partial<CourierService>
  ) => {
    updateCourierServiceCallApi(
      putCourierService(values.courierId, courierServiceId, {
        name: dto.name,
        typePriorityId: dto.typePriorityId
      })
    )
      .then(() => notify('Courier actualizado exitosamente', true))
      .catch(() => notify('No fue posible crear el courier.', false))
      .finally(getServices)
  }

  const requestDeleteCourierService = (
    courierId: number,
    courierServiceId: number
  ) => {
    deleteCourierServiceCallApi(
      deleteCourierService(courierId, courierServiceId)
    )
      .then(() => notify('Courier eliminado exitosamente', true))
      .catch(() => notify('No fue posible crear el courier.', false))
      .finally(getServices)
  }

  const handleClickSaveButton = (
    courierServiceId: number,
    name: string,
    typePriorityId: number
  ) => {
    let auxTypePriority = null
    if (typePriorityId > 0) {
      auxTypePriority = typePriorityId
    }
    update(courierServiceId, name, auxTypePriority)
  }

  return (
    <FieldArray name='courierServices'>
      {() => (
        <Grid container spacing={2} direction='row'>
          {values.courierServices.map((service, index) => (
            <Grid
              container
              item
              xs={12}
              sm={6}
              key={service.courierServiceId || index}
              spacing={1}
            >
              <Grid item xs={5}>
                <FastField
                  fullWidth
                  variant='outlined'
                  disabled={updateCourierServiceState.status === Status.Loading}
                  name={`courierServices[${index}].name`}
                  value={service.name}
                  onChange={handleChange}
                  label='Nombre de Servicio'
                  component={TextField}
                />
              </Grid>

              <Grid item xs={5}>
                <FastField name={`courierServices[${index}].typePriorityId`}>
                  {({ field }: FieldProps) => (
                    <PriorizationDDL
                      name={field.name}
                      value={field.value}
                      onChange={handleChange}
                      disabled={
                        updateCourierServiceState.status === Status.Loading
                      }
                    />
                  )}
                </FastField>
              </Grid>

              <Grid item xs={1}>
                <DeleteIconButton
                  disabled={deleteCourierServiceState.status === Status.Loading}
                  fontSize='small'
                  onClick={() =>
                    requestDeleteCourierService(
                      values.courierId,
                      service.courierServiceId
                    )
                  }
                />
              </Grid>

              <Grid item xs={1}>
                <SaveIconButton
                  disabled={
                    (values.courierServices[index].name ===
                      initialValues.courierServices[index].name &&
                      values.courierServices[index].typePriorityId ===
                        initialValues.courierServices[index].typePriorityId) ||
                    updateCourierServiceState.status === Status.Loading
                  }
                  fontSize='small'
                  onClick={() =>
                    handleClickSaveButton(
                      service.courierServiceId,
                      service.name,
                      service.typePriorityId || 0
                    )
                  }
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      )}
    </FieldArray>
  )
}
